import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ScreenType } from '../../../shared/enums/screen-type.enum';
import { DecodedTokenI } from '../../../shared/interfaces/decoded-token.interface';
import { UserI } from '../../../shared/interfaces/user.interface';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly loggedInUser: Subject<UserI | null> = new Subject();

  private readonly isSideMenuOpen: Subject<boolean> = new Subject();

  private readonly screenType: Subject<ScreenType> = new Subject();

  constructor(private readonly storageService: StorageService) {}

  addLoggedInUser(user: UserI) {
    this.loggedInUser.next(user);
  }

  getLoggedInUser$() {
    return this.loggedInUser.asObservable();
  }

  addIsSideMenuOpen(isSideMenuOpen: boolean) {
    this.isSideMenuOpen.next(isSideMenuOpen);
  }

  getIsSideMenuOpen$() {
    return this.isSideMenuOpen.asObservable();
  }

  addScreenType(screenType: ScreenType) {
    this.screenType.next(screenType);
  }

  getScreenType$() {
    return this.screenType.asObservable();
  }

  getDecodedToken(): DecodedTokenI {
    return JSON.parse(atob(this.storageService.accessToken?.split('.')[1]!));
  }
}
